import { Controller } from '@hotwired/stimulus'

export default class ShowcaseController extends Controller {
  connect() {
    this.image = []
  }

  checkSaleDate(e) {
    if ($(e.target).prop('checked')) {
      $('.end-date-input').removeClass('d-none')
    } else {
      $('.end-date-input').addClass('d-none')
      $('#showcase_sale_end_date').val('')
    }
  }

  checkAddress(e) {
    if ($(e.target).prop('checked')) {
      $('.address-form').addClass('d-none')
    }
  }

  checkAddressForm(e) {
    $('.address-form').removeClass('d-none')
    $('.suggestion-address').each(function (index, element) {
      if ($(element).prop('checked')) {
        $(element).prop('checked', false)
      }
    })
  }

  selectShowcase(e) {
    if ($(e.currentTarget).hasClass('selected-cases')) {
      $(e.currentTarget).removeClass('selected-cases')
      let count = $('.selected-cases').length
      if (count > 0) {
        $('.selected-item-button').removeClass('d-none')
        $('.selected-item-count').text(`${count} ${count === 1 ? 'Item' : 'Items'} Selected`)
      } else {
        $('.selected-item-button').addClass('d-none')
      }
    } else {
      $(e.currentTarget).addClass('selected-cases')
      let count = $('.selected-cases').length
      if (count > 0) {
        $('.selected-item-button').removeClass('d-none')
        $('.selected-item-count').text(`${count} ${count === 1 ? 'Item' : 'Items'} Selected`)
      } else {
        $('.selected-item-button').addClass('d-none')
      }
    }
    this.image.push($(e.currentTarget).attr('data-number'))
  }

  saveItem() {
    fetch('/shopping_bags/save_showcase', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        Accept: 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        showcase_ids: this.image
      })
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
        $('.selected-item-button').addClass('d-none')
      })
  }

  buyItem(e) {
    fetch('/showcases/multiple_buy_now', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        Accept: 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        showcase_ids: this.image
      })
    })
      .then((r) => r.text())
      .then((response) => {
        let truck_modal = document.getElementById('shareRecipeScrollModal')
        const modal = bootstrap.Modal.getInstance(truck_modal)
        modal.show()
        Turbo.renderStreamMessage(response)
      })
  }

  changeData(e) {
    let input = $(e.target)
    let options = $(e.target).closest('.select-container').find('.option')
    let hiddenInput = input.parent('div').find('input:hidden')
    const toggle = input
      .closest('.dropdown')
      .find('[data-bs-toggle="dropdown"]')[0]

    options.each(function (index, e) {
      e.addEventListener('click', (event) => {
        event.stopPropagation()
        input.val(e.dataset.name.replaceAll(/Price\s*:\s*/gi, '').trim())
        hiddenInput.attr('value', e.dataset.value)
        hiddenInput.attr('name', e.dataset.id)
        options.each(function (index, e) {
          e.classList.remove('selected')
          $('#sort_form')[0].requestSubmit()
        })
        e.classList.add('selected')
        // Close dropdown after selecting an option
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle)
        dropdown?.hide()
      })
    })
  }

  changeTabContent(e) {
    $('#searches_showcase_search_type').val(e.target.dataset.type);
    const form = $('form[data-controller="turbo-form-request user"]');
    form[0].requestSubmit();

    let pane = $('.profile-tab-pane1')
    let sibling = $('.home-tab-pane1')
    if ($(e.target).attr('id') === 'profile-tab1') {
      sibling.removeClass('show active')
      pane.addClass('show active')
    } else {
      pane.removeClass('show active')
      sibling.addClass('show active')
    }
  }

  hideModel(e) {
    if ($('#shareRecipeScrollModal').is(':visible')) {
      const modal = bootstrap.Modal.getInstance($('#shareRecipeScrollModal'))
      modal.hide()
    }

    if ($('#shareRecipeModal').is(':visible')) {
      const modal = bootstrap.Modal.getInstance($('#shareRecipeModal'))
      modal.hide()
    }
  }
}
